import { createWithEqualityFn as create } from "zustand/traditional";

type StepperNavStoreState = {
  clickedButton: "NEXT" | "PREVIOUS" | null;
  updateClickedButton: (button: "NEXT" | "PREVIOUS") => void;
  resetStore: () => void;
};

export const useOldStepperStore = create<StepperNavStoreState>()(set => ({
  clickedButton: null,
  updateClickedButton: (button: "NEXT" | "PREVIOUS") =>
    set({ clickedButton: button }),
  resetStore: () =>
    set({
      clickedButton: null,
    }),
}));
